import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAILER_HOME = {
  nickname: 'PRODUCTS.TRAILER_HOME.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' }
        ]
      }
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.15', value: '15000' }
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      TRAILER_HOME: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^([a-zA-Z]{2}\d{4,5})$/)
      ]]
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'isTrailerStationary', key: 'IS_TRAILER_STATIONARY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'contentsSumInsured', key: 'HOUSE_CONTENT_SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.100', value: '100' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.150', value: '150' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.200', value: '200' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.250', value: '250' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.300', value: '300' }
        ]
      }
    }
  ],
  icon:'trailer-home'
};
